import { leftArrow } from "@simplybusiness/icons";
import { useEnvironmentValues } from "../../../../../hooks/environment";
import { BackAction as BackActionComponent } from "./BackAction";
import type { BackActionProps } from "./types";

export const BackAction = (props: BackActionProps) => {
  const { site } = useEnvironmentValues();

  if (site === "moneysupermarket") {
    return <BackActionComponent {...props} icon={leftArrow} iconSize="sm" />;
  }

  return <BackActionComponent {...props} />;
};

export type { BackActionProps } from "./types";
